import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { STORYBLOK_BMI_CALCULATOR_CATEGORY } from './STORYBLOK_BMI_CALCULATOR_CATEGORY'
import { STORYBLOK_BMI_CALCULATOR_LIMIT } from './STORYBLOK_BMI_CALCULATOR_LIMIT'

import styles from './StoryblokBmiCalculatorCategoryTable.module.css'

// eslint-disable-next-line max-lines-per-function -- pure HTML table markup
export const StoryblokBmiCalculatorCategoryTable: FC = () => (
  <table className={styles['storyblok-bmi-calculator-category-table']}>
    <thead>
      <tr>
        <th
          className={
            styles['storyblok-bmi-calculator-category-table__head-cell']
          }
        >
          <FormattedMessage id="bmi.calculator.categoryTable.head.range" />
        </th>
        <th
          className={
            styles['storyblok-bmi-calculator-category-table__head-cell']
          }
        >
          <FormattedMessage id="bmi.calculator.categoryTable.head.rangeMeaning" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <span
            className={
              styles['storyblok-bmi-calculator-category-table__bmi-range']
            }
          >
            <FormattedMessage
              id="bmi.calculator.categoryTable.body.underweightValue"
              values={{
                underweightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.UNDERWEIGHT,
              }}
            />
          </span>
        </td>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <FormattedMessage
            id="bmi.calculator.category"
            values={{
              category: STORYBLOK_BMI_CALCULATOR_CATEGORY.UNDERWEIGHT,
            }}
          />
        </td>
      </tr>
      <tr>
        <td
          className={clsx(
            styles['storyblok-bmi-calculator-category-table__body-cell'],
            styles['storyblok-bmi-calculator-category-table__body-cell_normal'],
          )}
        >
          <span
            className={clsx(
              styles['storyblok-bmi-calculator-category-table__bmi-range'],
              styles[
                'storyblok-bmi-calculator-category-table__bmi-range_normal'
              ],
            )}
          >
            <FormattedMessage
              id="bmi.calculator.categoryTable.body.normalWeightValue"
              values={{
                normalWeightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.NORMAL_WEIGHT,
                underweightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.UNDERWEIGHT,
              }}
            />
          </span>
        </td>
        <td
          className={clsx(
            styles['storyblok-bmi-calculator-category-table__body-cell'],
            styles['storyblok-bmi-calculator-category-table__body-cell_normal'],
          )}
        >
          <FormattedMessage
            id="bmi.calculator.category"
            values={{
              category: STORYBLOK_BMI_CALCULATOR_CATEGORY.NORMAL_WEIGHT,
            }}
          />
        </td>
      </tr>
      <tr>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <span
            className={
              styles['storyblok-bmi-calculator-category-table__bmi-range']
            }
          >
            <FormattedMessage
              id="bmi.calculator.categoryTable.body.overweightValue"
              values={{
                normalWeightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.NORMAL_WEIGHT,
                overweightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.OVERWEIGHT,
              }}
            />
          </span>
        </td>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <FormattedMessage
            id="bmi.calculator.category"
            values={{
              category: STORYBLOK_BMI_CALCULATOR_CATEGORY.OVERWEIGHT,
            }}
          />
        </td>
      </tr>
      <tr>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <span
            className={
              styles['storyblok-bmi-calculator-category-table__bmi-range']
            }
          >
            <FormattedMessage
              id="bmi.calculator.categoryTable.body.obesityValue"
              values={{
                overweightLimit: STORYBLOK_BMI_CALCULATOR_LIMIT.OVERWEIGHT,
              }}
            />
          </span>
        </td>
        <td
          className={
            styles['storyblok-bmi-calculator-category-table__body-cell']
          }
        >
          <FormattedMessage
            id="bmi.calculator.category"
            values={{
              category: STORYBLOK_BMI_CALCULATOR_CATEGORY.OBESITY,
            }}
          />
        </td>
      </tr>
    </tbody>
  </table>
)
